import axios from "axios";

axios.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    const userPoolId = window.__userPoolId__;
    const tenantId = window.__tenantId__;

    config.headers[
      window.__config__?.api?.headers?.keys?.["userpool-id"] ||
        "x-authing-userpool-id"
    ] = userPoolId;
    config.headers[
      window.__config__?.api?.headers?.keys?.["app-id"] || "x-authing-app-id"
    ] = window.__appId__;
    config.headers[
      window.__config__?.api?.headers?.keys["request-from"] ||
        "x-authing-request-from"
    ] = "userPortal";
    if (tenantId) {
      config.headers["x-authing-app-tenant-id"] = tenantId;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
